module.exports = __webpack_public_path__ + "img/magical.25f6bbfc.png";